(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-kundali-calculator"] && !Shopify.designMode) return;
  try {
    
;(function () {
  'use strict';
  // GG-KUNDLI-BUILD: v5-visibility-fix (search this string to confirm this file is live)

  const SIGNS = ['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];

  // Centroids for a classic North Indian diamond chart (400x400 viewBox)
  // House 1 = top diamond, then clockwise
  const HOUSE_POS = {
    1: { x: 200, y: 95 },  2: { x: 100, y: 45 },  3: { x: 45, y: 100 },
    4: { x: 100, y: 200 }, 5: { x: 45, y: 300 },  6: { x: 100, y: 355 },
    7: { x: 200, y: 305 }, 8: { x: 300, y: 355 }, 9: { x: 355, y: 300 },
    10:{ x: 300, y: 200 }, 11:{ x: 355, y: 100 }, 12:{ x: 300, y: 45 }
  };
  const SIGN_LABEL_POS = {
    1: { x: 200, y: 60 },  2: { x: 100, y: 18 },  3: { x: 20, y: 60 },
    4: { x: 55, y: 200 },  5: { x: 20, y: 340 },  6: { x: 100, y: 382 },
    7: { x: 200, y: 340 }, 8: { x: 300, y: 382 }, 9: { x: 380, y: 340 },
    10:{ x: 345, y: 200 }, 11:{ x: 380, y: 60 },  12:{ x: 300, y: 18 }
  };

  function abbreviate(name) {
    const map = { Sun: 'Su', Moon: 'Mo', Mars: 'Ma', Mercury: 'Me', Jupiter: 'Ju', Venus: 'Ve', Saturn: 'Sa', Rahu: 'Ra', Ketu: 'Ke', Uranus: 'Ur', Neptune: 'Ne', Pluto: 'Pl' };
    return map[name] || (name || '').slice(0, 2);
  }

  // ---------- Starfield ----------
  function buildStarfield(container) {
    if (!container) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const count = window.innerWidth < 700 ? 45 : 90;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const star = document.createElement('span');
      star.className = 'gk-star';
      star.style.left = (Math.random() * 100).toFixed(2) + '%';
      star.style.top = (Math.random() * 100).toFixed(2) + '%';
      const size = (Math.random() * 2 + 1).toFixed(1);
      star.style.width = size + 'px';
      star.style.height = size + 'px';
      if (!reduceMotion) {
        star.style.animationDuration = (2.5 + Math.random() * 3.5).toFixed(2) + 's';
        star.style.animationDelay = (Math.random() * 5).toFixed(2) + 's';
      } else {
        star.style.opacity = '0.6';
      }
      frag.appendChild(star);
    }
    container.appendChild(frag);
  }

  // ---------- PDF report ----------
  function drawChartPdf(doc, originX, originY, size, ascendantIndex, planets, title) {
    const scale = size / 400;
    const gold = [201, 150, 44], ink = [35, 25, 18];
    const asc = ascendantIndex || 1;
    const tx = (x) => originX + x * scale;
    const ty = (y) => originY + y * scale;

    if (title) {
      doc.setTextColor(gold[0], gold[1], gold[2]);
      doc.setFont('times', 'bold'); doc.setFontSize(11);
      doc.text(title, originX + size / 2, originY - 8, { align: 'center' });
    }

    doc.setDrawColor(gold[0], gold[1], gold[2]);
    doc.setLineWidth(0.8);
    doc.rect(originX, originY, size, size);
    doc.line(tx(2), ty(2), tx(398), ty(398));
    doc.line(tx(398), ty(2), tx(2), ty(398));
    doc.line(tx(200), ty(2), tx(398), ty(200));
    doc.line(tx(398), ty(200), tx(200), ty(398));
    doc.line(tx(200), ty(398), tx(2), ty(200));
    doc.line(tx(2), ty(200), tx(200), ty(2));

    const byHouse = {};
    (planets || []).forEach(p => {
      const h = p.house || 1;
      byHouse[h] = byHouse[h] || [];
      byHouse[h].push(p);
    });

    for (let house = 1; house <= 12; house++) {
      const signIndex = ((asc - 1 + (house - 1)) % 12) + 1;
      const sPos = SIGN_LABEL_POS[house];
      doc.setFont('helvetica', 'normal'); doc.setFontSize(6.5);
      doc.setTextColor(gold[0], gold[1], gold[2]);
      doc.text(String(signIndex), tx(sPos.x), ty(sPos.y), { align: 'center' });

      const planetsHere = byHouse[house] || [];
      const pos = HOUSE_POS[house];
      doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
      doc.setTextColor(ink[0], ink[1], ink[2]);
      planetsHere.forEach((p, i) => {
        const label = abbreviate(p.name) + (p.retro ? 'R' : '');
        const lineHeight = 9;
        const yOff = (i * lineHeight) - ((planetsHere.length - 1) * lineHeight / 2);
        doc.text(label, tx(pos.x), ty(pos.y) + yOff, { align: 'center' });
      });
    }
  }

  function generatePdf(data) {
    if (!window.jspdf) return null;
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
    const maroon = [92, 15, 30], gold = [201, 150, 44], ink = [35, 25, 18];
    const marginX = 48;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    let y = 100;

    function drawHeader() {
      doc.setFillColor(maroon[0], maroon[1], maroon[2]);
      doc.rect(0, 0, pageWidth, 70, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFont('times', 'bold'); doc.setFontSize(20);
      doc.text('GarunGems - Janam Kundli Report', marginX, 42);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
      doc.text('garungems.com', pageWidth - marginX, 42, { align: 'right' });
    }
    function addPage() {
      doc.addPage();
      drawHeader();
      y = 100;
    }
    function ensureSpace(needed) {
      if (y + needed > pageHeight - 50) addPage();
    }
    function sectionTitle(label) {
      ensureSpace(40);
      doc.setTextColor(gold[0], gold[1], gold[2]);
      doc.setFont('times', 'bold'); doc.setFontSize(15);
      doc.text(label, marginX, y);
      doc.setDrawColor(gold[0], gold[1], gold[2]);
      doc.line(marginX, y + 6, pageWidth - marginX, y + 6);
      y += 26;
    }
    function row(label, value) {
      if (!value) return;
      ensureSpace(18);
      doc.setTextColor(ink[0], ink[1], ink[2]);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
      doc.text(String(label), marginX, y);
      doc.setFont('helvetica', 'normal');
      doc.text(String(value), marginX + 150, y);
      y += 16;
    }

    drawHeader();

    // ---- Page 1: Basic (Birth Details + Panchang + Avakhada) ----
    sectionTitle('Birth Details');
    row('Name', data.basic.name); row('Gender', data.basic.gender);
    row('Date of Birth', data.basic.dob); row('Time of Birth', data.basic.tob);
    row('Place of Birth', data.basic.pob); row('Ascendant', data.basic.ascendant);
    y += 8;

    sectionTitle('Panchang');
    row('Tithi', data.panchang.tithi); row('Karana', data.panchang.karana);
    row('Yoga', data.panchang.yoga); row('Nakshatra', data.panchang.nakshatra);
    row('Nakshatra Lord', data.panchang.nakshatra_lord);
    row('Sunrise', data.panchang.sunrise); row('Sunset', data.panchang.sunset);
    y += 8;

    sectionTitle('Avakhada Details');
    row('Varna', data.avakhada.varna); row('Vashya', data.avakhada.vashya);
    row('Yoni', data.avakhada.yoni); row('Gan', data.avakhada.gan);
    row('Nadi', data.avakhada.nadi); row('Moon Sign', data.avakhada.sign);
    row('Sign Lord', data.avakhada.sign_lord); row('Charan', data.avakhada.charan);
    row('Tatva', data.avakhada.tatva);

    // ---- Page 2: Kundli (birth charts + planetary positions) ----
    addPage();
    sectionTitle('Birth Charts');
    const chartSize = 190;
    ensureSpace(chartSize + 30);
    const chartY = y + 20;
    drawChartPdf(doc, marginX, chartY, chartSize, data.basic.ascendant_index, data.planets, 'Lagna Chart (D1)');
    drawChartPdf(doc, marginX + chartSize + 40, chartY, chartSize, data.navamsa_ascendant_index || data.basic.ascendant_index, data.navamsa, 'Navamsa Chart (D9)');
    y = chartY + chartSize + 30;

    sectionTitle('Planetary Positions');
    const cols = ['Planet', 'Sign', 'Nakshatra', 'Degree', 'House'];
    const colX = [marginX, marginX + 85, marginX + 175, marginX + 300, marginX + 390];
    doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.setTextColor(ink[0], ink[1], ink[2]);
    cols.forEach((c, i) => doc.text(c, colX[i], y));
    y += 14;
    doc.setFont('helvetica', 'normal');
    (data.planets || []).forEach(p => {
      ensureSpace(14);
      doc.text(String(p.name || ''), colX[0], y);
      doc.text(String(p.sign || ''), colX[1], y);
      doc.text(String(p.nakshatra || ''), colX[2], y);
      doc.text(String(p.degree || ''), colX[3], y);
      doc.text(String(p.house || ''), colX[4], y);
      y += 14;
    });

    // ---- Page 3: Dasha ----
    if (data.dasha && data.dasha.length) {
      addPage();
      sectionTitle('Vimshottari Mahadasha');
      doc.setFontSize(9);
      data.dasha.forEach(d => {
        const start = d.start ? String(d.start).split('T')[0] : '';
        const end = d.end ? String(d.end).split('T')[0] : '';
        row(d.planet, `${start} - ${end}`);
      });
    }

    // ---- Free Report ----
    if (data.report_summary) {
      addPage();
      sectionTitle('Free Report');
      doc.setTextColor(ink[0], ink[1], ink[2]);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5);
      const wrapped = doc.splitTextToSize(data.report_summary, pageWidth - marginX * 2);
      wrapped.forEach(line => {
        ensureSpace(16);
        doc.text(line, marginX, y);
        y += 16;
      });
    }

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8); doc.setTextColor(150, 150, 150);
      doc.text('Generated by GarunGems - garungems.com', marginX, pageHeight - 24);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - marginX, pageHeight - 24, { align: 'right' });
    }
    return doc;
  }

  function initAll() {
    document.querySelectorAll('.gg-kundli').forEach((root) => {
      if (root.dataset.gkInitialized) return;
      root.dataset.gkInitialized = 'true';
      try {
        initSection(root);
      } catch (err) {
        // Content is visible by default via CSS now (see [data-gk-reveal] rule),
        // so a JS error here no longer leaves the section blank - it just
        // means interactivity (form, tabs, PDF, etc.) won't work, and we log
        // it clearly so it's easy to spot in devtools.
        console.error('GG Kundli Calculator failed to initialize:', err);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function initSection(root) {
    const apiEndpoint = (root.dataset.apiEndpoint || '').trim();
    const whatsapp = root.dataset.whatsapp;

    const form = root.querySelector('#gk-kundli-form');
    const generateBtn = root.querySelector('#gk-generate-btn');
    const btnLabel = generateBtn.querySelector('.gk-btn-label');
    const spinner = generateBtn.querySelector('.gk-spinner');
    const formError = root.querySelector('#gk-form-error');
    const formPanel = root.querySelector('#gk-form-panel');
    const resultsPanel = root.querySelector('#gk-results');
    const pdfBanner = root.querySelector('#gk-pdf-banner');

    let currentResult = null;

    try {
      buildStarfield(root.querySelector('#gk-stars'));
    } catch (err) {
      console.error('Kundli starfield error (non-fatal):', err);
    }

    // ---- Gender toggle ----
    root.querySelectorAll('.gk-toggle-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('.gk-toggle-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        root.querySelector('#gk-gender').value = btn.dataset.gender;
      });
    });

    // ---- Place autocomplete ----
    // Tries OpenStreetMap Nominatim first, then falls back to the Open-Meteo
    // geocoding API if Nominatim is blocked/rate-limited/unreachable (this
    // happens more often than you'd expect inside embedded/preview iframes
    // like the Shopify theme editor). Selecting a suggestion silently fills
    // the hidden latitude/longitude fields - the shopper never sees them.
    const placeInput = root.querySelector('#gk-place');
    const suggestBox = root.querySelector('#gk-place-suggestions');
    const latField = root.querySelector('#gk-lat');
    const lonField = root.querySelector('#gk-lon');
    let placeCoords = null;
    let geocodeTimer = null;

    placeInput.addEventListener('input', () => {
      placeCoords = null;
      latField.value = '';
      lonField.value = '';
      clearTimeout(geocodeTimer);
      const q = placeInput.value.trim();
      if (q.length < 3) { suggestBox.hidden = true; return; }
      suggestBox.innerHTML = '<div class="gk-suggest-offline">Searching...</div>';
      suggestBox.hidden = false;
      geocodeTimer = setTimeout(() => geocodePlace(q), 400);
    });

    async function fetchJson(url, options) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 6000);
      try {
        const res = await fetch(url, { ...options, signal: controller.signal });
        clearTimeout(timeout);
        if (!res.ok) return null;
        return await res.json();
      } catch (err) {
        clearTimeout(timeout);
        console.warn('Geocode request failed for', url, err);
        return null;
      }
    }

    async function geocodeNominatim(query) {
      const data = await fetchJson(
        `https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=0&limit=5&q=${encodeURIComponent(query)}`,
        { headers: { 'Accept-Language': 'en' } }
      );
      if (!Array.isArray(data)) return null;
      return data.map(item => ({ label: item.display_name, lat: parseFloat(item.lat), lon: parseFloat(item.lon) }));
    }

    async function geocodeOpenMeteo(query) {
      const data = await fetchJson(
        `https://geocoding-api.open-meteo.com/v1/search?count=5&language=en&format=json&name=${encodeURIComponent(query)}`
      );
      if (!data || !Array.isArray(data.results)) return null;
      return data.results.map(r => ({
        label: [r.name, r.admin1, r.country].filter(Boolean).join(', '),
        lat: r.latitude,
        lon: r.longitude
      }));
    }

    async function geocodePlace(query) {
      let results = await geocodeNominatim(query);
      if (!results || !results.length) results = await geocodeOpenMeteo(query);

      if (!results || !results.length) {
        suggestBox.innerHTML = '<div class="gk-suggest-offline">No matches found. Try adding the state/country, or check your spelling.</div>';
        suggestBox.hidden = false;
        return;
      }

      suggestBox.innerHTML = '';
      results.forEach(item => {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = item.label;
        b.addEventListener('click', () => {
          placeInput.value = item.label;
          placeCoords = { lat: item.lat, lon: item.lon };
          latField.value = item.lat;
          lonField.value = item.lon;
          suggestBox.hidden = true;
        });
        suggestBox.appendChild(b);
      });
      suggestBox.hidden = false;
    }

    document.addEventListener('click', (e) => {
      if (!suggestBox.contains(e.target) && e.target !== placeInput) suggestBox.hidden = true;
    });

    // ---- Tabs ----
    root.querySelectorAll('.gk-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        root.querySelectorAll('.gk-tab').forEach(t => t.classList.remove('is-active'));
        root.querySelectorAll('.gk-tabpanel').forEach(p => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        root.querySelector(`[data-panel="${tab.dataset.tab}"]`).classList.add('is-active');
      });
    });

    // ---- New Kundli button ----
    root.querySelector('#gk-new-kundli-btn').addEventListener('click', () => {
      resultsPanel.hidden = true;
      formPanel.hidden = false;
      if (pdfBanner) pdfBanner.hidden = true;
      form.reset();
    });

    // ---- WhatsApp CTA ----
    const waLink = root.querySelector('#gk-whatsapp-cta');
    waLink.addEventListener('click', (e) => {
      e.preventDefault();
      const name = currentResult?.basic?.name || '';
      const msg = encodeURIComponent(`Hi, I just generated ${name ? name + "'s " : 'my '}Kundli on GarunGems and I'd like a deeper reading.`);
      window.open(`https://wa.me/${whatsapp}?text=${msg}`, '_blank', 'noopener');
    });

    // ---- PDF download ----
    const pdfBtn = root.querySelector('#gk-download-pdf');
    if (pdfBtn) {
      const pdfSpinner = root.querySelector('#gk-pdf-spinner');
      const pdfLabel = root.querySelector('#gk-pdf-btn-label');
      const originalPdfLabel = pdfLabel ? pdfLabel.textContent : 'Download PDF Report';
      pdfBtn.addEventListener('click', () => {
        if (!currentResult) return;
        pdfBtn.disabled = true;
        if (pdfSpinner) pdfSpinner.hidden = false;
        if (pdfLabel) pdfLabel.textContent = 'Preparing...';
        setTimeout(() => {
          try {
            const doc = generatePdf(currentResult);
            if (!doc) {
              alert('The PDF library is still loading - please try again in a moment.');
            } else {
              const safeName = (currentResult.basic.name || 'kundli').replace(/[^a-z0-9]+/gi, '_');
              doc.save(`${safeName}-kundli-garungems.pdf`);
            }
          } catch (err) {
            console.error('PDF generation error:', err);
            alert('Could not generate the PDF. Please try again.');
          } finally {
            pdfBtn.disabled = false;
            if (pdfSpinner) pdfSpinner.hidden = true;
            if (pdfLabel) pdfLabel.textContent = originalPdfLabel;
          }
        }, 30);
      });
    }

    // ---- Saved kundlis (localStorage) ----
    const STORAGE_KEY = 'ggems_saved_kundlis';
    function getSaved() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; } }
    function setSaved(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 5))); }
    function renderSaved() {
      const list = getSaved();
      const box = root.querySelector('#gk-saved-list');
      if (!list.length) {
        box.innerHTML = `<div class="gk-empty-state"><div class="gk-empty-icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg></div><p>Your last 5 kundlis are saved automatically on this device</p></div>`;
        return;
      }
      box.innerHTML = '';
      list.forEach((entry, idx) => {
        const item = document.createElement('div');
        item.className = 'gk-saved-item';
        item.innerHTML = `<div><div class="gk-saved-name">${entry.basic.name}</div><div class="gk-saved-meta">${entry.basic.dob} - ${entry.basic.pob}</div></div><button type="button" class="gk-saved-remove" aria-label="Remove">x</button>`;
        item.addEventListener('click', (e) => {
          if (e.target.closest('.gk-saved-remove')) return;
          renderResults(entry);
        });
        item.querySelector('.gk-saved-remove').addEventListener('click', () => {
          const l = getSaved(); l.splice(idx, 1); setSaved(l); renderSaved();
        });
        box.appendChild(item);
      });
    }
    renderSaved();

    // ---- Form submit ----
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      formError.hidden = true;

      const name = root.querySelector('#gk-name').value.trim();
      const gender = root.querySelector('#gk-gender').value;
      const date = root.querySelector('#gk-date').value;
      const time = root.querySelector('#gk-time').value;
      const place = placeInput.value.trim();
      const phone = root.querySelector('#gk-phone').value.trim();

      const lat = root.querySelector('#gk-lat').value;
      const lon = root.querySelector('#gk-lon').value;
      const tz = parseFloat(root.querySelector('#gk-tz').value || '5.5');

      if (!name || !date || !time || !place) {
        showError('Please fill in name, birth date, time and place.');
        return;
      }
      if (!lat || !lon || !placeCoords) {
        showError('Please select your birth place from the suggestions list so we can detect its coordinates.');
        return;
      }
      if (!apiEndpoint) {
        showError('Astrology API is not connected yet. Add your Apps Script Web App URL in Theme Editor -> Kundli Calculator -> API connection.');
        return;
      }

      setLoading(true);

      const payload = {
        name, gender, date, time, place,
        latitude: parseFloat(lat), longitude: parseFloat(lon), timezone: tz
      };
      if (phone) payload.phone = phone;

      fetch(`${apiEndpoint}?action=full_kundli`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' }, // avoids CORS preflight on Apps Script
        body: JSON.stringify(payload)
      })
        .then(async (r) => {
          const raw = await r.text();
          let data;
          try {
            data = JSON.parse(raw);
          } catch (parseErr) {
            // The server responded, but not with JSON - this is the classic
            // "nothing happens" cause: usually the Apps Script isn't
            // deployed with access set to "Anyone", so Google returns an
            // HTML sign-in/error page instead of your JSON payload.
            console.error('Kundli API returned non-JSON response:', raw.slice(0, 500));
            throw new Error('The astrology service returned an unexpected response. Check that your Apps Script is deployed with access set to "Anyone", and that the URL ends in /exec.');
          }
          if (!r.ok || data.error) {
            throw new Error(data.error || `Server responded with status ${r.status}.`);
          }
          return data;
        })
        .then(data => {
          const list = getSaved();
          list.unshift(data);
          setSaved(list);
          renderSaved();
          renderResults(data);
        })
        .catch(err => {
          console.error('Kundli API error:', err);
          if (!navigator.onLine) {
            showError('You appear to be offline. Please check your internet connection and try again.');
          } else if (err.name === 'AbortError') {
            showError('The astrology service took too long to respond. Please try again.');
          } else {
            showError(err.message || 'Something went wrong generating this Kundli. Please try again in a moment.');
          }
        })
        .finally(() => setLoading(false));
    });

    function showError(msg) { formError.textContent = msg; formError.hidden = false; }

    function setLoading(isLoading) {
      generateBtn.disabled = isLoading;
      spinner.hidden = !isLoading;
      btnLabel.textContent = isLoading ? 'Calculating...' : 'Generate Kundli';
    }

    // ---- Render results ----
    function renderResults(data) {
      currentResult = data;
      formPanel.hidden = true;
      resultsPanel.hidden = false;
      if (pdfBanner) pdfBanner.hidden = false;

      root.querySelector('#gk-result-name').textContent = `${data.basic.name}'s Kundli`;
      root.querySelector('#gk-result-meta').textContent = `${data.basic.dob} - ${data.basic.tob} - ${data.basic.pob}`;

      renderDL(root.querySelector('#gk-birth-details'), {
        Name: data.basic.name, Gender: data.basic.gender, 'Date of Birth': data.basic.dob,
        'Time of Birth': data.basic.tob, 'Place of Birth': data.basic.pob,
        Latitude: data.basic.latitude, Longitude: data.basic.longitude, Timezone: data.basic.timezone
      });
      renderDL(root.querySelector('#gk-panchang-details'), {
        Tithi: data.panchang.tithi, Karana: data.panchang.karana, Yoga: data.panchang.yoga,
        Nakshatra: data.panchang.nakshatra, 'Nakshatra Lord': data.panchang.nakshatra_lord,
        Ascendant: data.basic.ascendant, Sunrise: data.panchang.sunrise, Sunset: data.panchang.sunset
      });
      renderDL(root.querySelector('#gk-avakhada-details'), {
        Varna: data.avakhada.varna, Vashya: data.avakhada.vashya, Yoni: data.avakhada.yoni,
        Gan: data.avakhada.gan, Nadi: data.avakhada.nadi, Sign: data.avakhada.sign,
        'Sign Lord': data.avakhada.sign_lord, Charan: data.avakhada.charan,
        Tatva: data.avakhada.tatva
      });

      drawChart(root.querySelector('#gk-chart-d1'), data.basic.ascendant_index, data.planets);
      drawChart(root.querySelector('#gk-chart-d9'), data.navamsa_ascendant_index || data.basic.ascendant_index, data.navamsa);

      renderPlanetTable(root.querySelector('#gk-planet-table tbody'), data.planets);
      renderDasha(root.querySelector('#gk-dasha-timeline'), data.dasha || []);

      const reportText = root.querySelector('#gk-report-summary-text');
      if (data.report_summary) reportText.textContent = data.report_summary;

      root.querySelector('.gk-tab[data-tab="basic"]').click();
      resultsPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderDL(container, obj) {
      container.innerHTML = '';
      Object.entries(obj).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        const div = document.createElement('div');
        div.innerHTML = `<dt>${k}</dt><dd>${v}</dd>`;
        container.appendChild(div);
      });
    }

    function renderPlanetTable(tbody, planets) {
      tbody.innerHTML = '';
      (planets || []).forEach(p => {
        const tr = document.createElement('tr');
        tr.innerHTML = `
          <td>${p.name}</td><td>${p.sign}</td><td>${p.sign_lord || '-'}</td>
          <td>${p.nakshatra || '-'}</td><td>${p.nakshatra_lord || '-'}</td>
          <td>${p.degree || '-'}</td><td>${p.retro ? 'Yes' : 'No'}</td><td>${p.house}</td>
          <td>${p.status ? `<span class="gk-badge ${p.status.toLowerCase()}">${p.status}</span>` : '-'}</td>`;
        tbody.appendChild(tr);
      });
    }

    function renderDasha(container, dashaList) {
      container.innerHTML = '';
      if (!dashaList.length) { container.innerHTML = '<p style="opacity:.6;font-size:.85rem;">Dasha data unavailable.</p>'; return; }
      const totalStart = new Date(dashaList[0].start).getTime();
      const totalEnd = new Date(dashaList[dashaList.length - 1].end).getTime();
      const totalSpan = totalEnd - totalStart || 1;
      dashaList.forEach(d => {
        const row = document.createElement('div');
        row.className = 'gk-dasha-row' + (d.current ? ' is-current' : '');
        const start = new Date(d.start).getTime();
        const end = new Date(d.end).getTime();
        const pct = Math.max(4, Math.round(((end - start) / totalSpan) * 100));
        row.innerHTML = `
          <div class="gk-dasha-planet">${d.planet}</div>
          <div class="gk-dasha-bar-track"><div class="gk-dasha-bar-fill" style="width:${pct}%"></div></div>
          <div class="gk-dasha-dates">${formatDate(d.start)} - ${formatDate(d.end)}</div>`;
        container.appendChild(row);
      });
    }

    function formatDate(iso) {
      const d = new Date(iso);
      if (isNaN(d)) return iso;
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    }

    // ---- North Indian chart (SVG) ----
    function drawChart(container, ascendantIndex, planets) {
      if (!container) return;
      const asc = ascendantIndex || 1;
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 400 400');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', 'Vedic astrology chart');

      const bg = document.createElementNS(ns, 'rect');
      bg.setAttribute('x', 2); bg.setAttribute('y', 2); bg.setAttribute('width', 396); bg.setAttribute('height', 396);
      bg.setAttribute('rx', 8); bg.setAttribute('class', 'gk-chart-svg-bg');
      svg.appendChild(bg);

      const lines = [
        'M2,2 L398,398', 'M398,2 L2,398',
        'M200,2 L398,200 L200,398 L2,200 Z',
        'M2,2 L398,2 L398,398 L2,398 Z'
      ];
      lines.forEach(d => {
        const path = document.createElementNS(ns, 'path');
        path.setAttribute('d', d);
        path.setAttribute('class', 'gk-chart-line');
        svg.appendChild(path);
      });

      // Group planets by house
      const byHouse = {};
      (planets || []).forEach(p => {
        const h = p.house || houseFromSign(p.sign_index, asc);
        byHouse[h] = byHouse[h] || [];
        byHouse[h].push(p);
      });

      for (let house = 1; house <= 12; house++) {
        const signIndex = ((asc - 1 + (house - 1)) % 12) + 1;
        const sPos = SIGN_LABEL_POS[house];
        const signText = document.createElementNS(ns, 'text');
        signText.setAttribute('x', sPos.x); signText.setAttribute('y', sPos.y);
        signText.setAttribute('text-anchor', 'middle');
        signText.setAttribute('class', 'gk-chart-sign');
        signText.textContent = signIndex;
        svg.appendChild(signText);

        const planetsHere = byHouse[house] || [];
        const pos = HOUSE_POS[house];
        planetsHere.forEach((p, i) => {
          const t = document.createElementNS(ns, 'text');
          t.setAttribute('x', pos.x);
          t.setAttribute('y', pos.y + (i * 15) - ((planetsHere.length - 1) * 7));
          t.setAttribute('text-anchor', 'middle');
          t.setAttribute('class', 'gk-chart-planet' + (p.retro ? ' gk-retro' : ''));
          t.textContent = abbreviate(p.name) + (p.retro ? '(R)' : '');
          svg.appendChild(t);
        });

        if (house === 1) {
          const marker = document.createElementNS(ns, 'path');
          marker.setAttribute('d', `M${pos.x - 14},${pos.y + 28} l14,-10 l14,10`);
          marker.setAttribute('class', 'gk-chart-asc-marker');
          marker.setAttribute('fill', 'none');
          svg.appendChild(marker);
        }
      }

      container.innerHTML = '';
      container.appendChild(svg);
    }

    function houseFromSign(signIndex, ascendantIndex) {
      if (!signIndex || !ascendantIndex) return 1;
      return ((signIndex - ascendantIndex + 12) % 12) + 1;
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-new-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-header')) {
    class GMHeader extends HTMLElement {
      connectedCallback() {
        const $ = (s) => this.querySelector(s);
        const drawer = $('[data-drawer]'), overlay = $('[data-overlay]'), burger = $('[data-open-drawer]');
        const openD = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); overlay.hidden = false; burger.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; };
        const closeD = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); overlay.hidden = true; burger.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; };
        burger && burger.addEventListener('click', openD);
        $('[data-close-drawer]').addEventListener('click', closeD);
        overlay.addEventListener('click', closeD);

        // Announcement bar
        const bar = $('[data-bar]');
        if (bar) {
          const key = 'gm-bar-closed-' + (this.dataset.end || 'x');
          try { if (sessionStorage.getItem(key)) bar.classList.add('is-hidden'); } catch (e) {}
          $('[data-bar-close]').addEventListener('click', () => { bar.classList.add('is-hidden'); try { sessionStorage.setItem(key, '1'); } catch (e) {} });
        }

        // Countdown (time entered in India time, IST)
        const cd = $('[data-countdown]');
        if (cd && this.dataset.end) {
          const end = new Date(this.dataset.end.trim().replace(' ', 'T') + ':00+05:30').getTime();
          const pad = (n) => String(n).padStart(2, '0');
          const tick = () => {
            let t = Math.max(0, end - Date.now());
            if (isNaN(end)) { cd.hidden = true; return; }
            const d = Math.floor(t / 864e5); t %= 864e5;
            const h = Math.floor(t / 36e5); t %= 36e5;
            const m = Math.floor(t / 6e4); const s = Math.floor((t % 6e4) / 1e3);
            cd.querySelector('[data-d]').textContent = pad(d);
            cd.querySelector('[data-h]').textContent = pad(h);
            cd.querySelector('[data-m]').textContent = pad(m);
            cd.querySelector('[data-s]').textContent = pad(s);
            if (end - Date.now() <= 0) { cd.hidden = true; clearInterval(this.timer); }
          };
          tick(); this.timer = setInterval(tick, 1000);
        }

        // Search with live suggestions
        const panel = $('[data-search-panel]'), sBtn = $('[data-open-search]'), input = $('[data-search-input]'), out = $('[data-results]');
        const toggleSearch = (open) => {
          panel.hidden = !open; sBtn.setAttribute('aria-expanded', String(open));
          if (open) setTimeout(() => input.focus(), 30);
        };
        sBtn.addEventListener('click', () => toggleSearch(panel.hidden));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { toggleSearch(false); closeD(); } });
        document.addEventListener('click', (e) => { if (!panel.hidden && !this.contains(e.target)) toggleSearch(false); });
        let timer, ctrl;
        input.addEventListener('input', () => {
          clearTimeout(timer);
          const q = input.value.trim();
          if (q.length < 2) { out.innerHTML = ''; return; }
          timer = setTimeout(async () => {
            if (ctrl) ctrl.abort(); ctrl = new AbortController();
            try {
              const r = await fetch('{{ routes.predictive_search_url }}.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: ctrl.signal });
              const data = await r.json();
              const items = (data.resources && data.resources.results && data.resources.results.products) || [];
              out.innerHTML = items.length ? items.map((p) =>
                '<a class="gmh__res" href="' + p.url + '"><img src="' + (p.image ? p.image + (p.image.includes('?') ? '&' : '?') + 'width=120' : '') + '" alt="" loading="lazy"><span>' + p.title + '</span><b>' + (p.price ? (window.Shopify && Shopify.currency ? '' : '') + Number(p.price).toLocaleString('en-IN', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', maximumFractionDigits: 0 }) : '') + '</b></a>'
              ).join('') : '<div class="gmh__res-empty">No products found for "' + q.replace(/</g, '&lt;') + '"</div>';
            } catch (err) { /* aborted */ }
          }, 220);
        });

        // Collapse the announcement bar on scroll
        if (this.dataset.sticky === 'true') {
          const onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 60);
          window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
        }

        // Live cart count: refresh after any add / change / update call
        const badge = $('[data-cart-count]');
        const refresh = () => fetch('/cart.js').then((r) => r.json()).then((c) => { badge.textContent = c.item_count; badge.hidden = c.item_count === 0; }).catch(() => {});
        if (!window.__gmFetchPatched) {
          window.__gmFetchPatched = true;
          const of = window.fetch;
          window.fetch = function (input) {
            const res = of.apply(this, arguments);
            try { const u = typeof input === 'string' ? input : input.url; if (/\/cart\/(add|change|update|clear)/.test(u)) res.then(() => setTimeout(() => document.dispatchEvent(new CustomEvent('gm:cart-changed')), 150)); } catch (e) {}
            return res;
          };
        }
        document.addEventListener('gm:cart-changed', refresh);
        ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added'].forEach((n) => document.addEventListener(n, refresh));
      }
      disconnectedCallback() { clearInterval(this.timer); }
    }
    customElements.define('gm-header', GMHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
